import SubPage from "@/layout/SubPage.vue"

export default {
  path: "health",
  name: "health",
  component: SubPage,
  meta: { title: "健康模块", icon: "dashboard" },
  hidden: true,
  props: true,
  children: [// --- 内容管理 ---
  ]
}
